module.exports = __webpack_public_path__ + "img/logo1.4c399e7b.png";